import React, {Component, Fragment} from 'react'
import FormContext from 'components/FormContext'
import DeleteIcon from '@material-ui/icons/Delete'
import styles from './styles'
import {Typography, Button, TextField, IconButton} from 'components/OptimisedMui'
import {InfoDialog, Markdown, MemberTitle, ReadOnly, TextAgreement, LinkButton, CallingCodeSelect} from 'components'
import EmailIcon from '@material-ui/icons/Email'
import EditIcon from '@material-ui/icons/Edit'
import OpenIcon from '@material-ui/icons/VerifiedUser'
import Tooltip from '@material-ui/core/Tooltip'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {Authorization, DialogHandler} from 'utils'
import { InputDialog } from 'components/InputDialog'
import {Select} from 'components'
import moment from 'moment'
import { Checkbox } from 'components/styled/Checkbox'
import {IdentityVerificationDetails} from 'components/account'

export class Kyc extends Component {
  static defaultProps = {
    name: 'account.steps.kyc',
  }

  state = {activeStatus: -1}
  personKycDialogHandler = new DialogHandler(this, 'kycDialog')
  editStatusDialogHandler = new DialogHandler(this, 'editStatusDialog')
  viewResultDialogHandler = new DialogHandler(this, 'viewResultDialog')

  handleAddPersonKyc = async() => {
    const {onChange, context: { country }, context} = this.props
    const name = await this.personKycDialogHandler.show()
    if (name) {
      onChange({...context, personKycs: [...context.personKycs, {name, status: 'unsent', callingCode: country.telephone}]})
    }
  }

  handleDeletePersonKyc = person => event => {
    const {onChange, context} = this.props
    onChange({...context, personKycs: context.personKycs.filter(p => p !== person)})
  }

  handleStatusClick = i => event => {
    this.setState({activeStatus: this.state.activeStatus === i ? -1 : i})
    event.preventDefault()
    event.stopPropagation()
  }

  handleSend = (method, person) => event => {
    this.props.onSendInstructions(method, person)
  }

  handleEditStatus = person => async(event) => {
    const {onChange, context} = this.props
    const status = await this.editStatusDialogHandler.show({initialValue: person.status})
    if (status)
      onChange({...context, personKycs: context.personKycs.map(p => p === person ? ({...p, status}) : p)})
  }

  handleViewResult = personKyc => event => {
    this.viewResultDialogHandler.show({personKyc})
  }

  handleShowKycConsent = () => {
    this.setState({showKycConsent: true})
  }

  handleEditKycConsent = () => {
    if (!this.props.context.kycTermsAgreed)
      this.handleShowKycConsent()
    else
      this.handleKycConsented(false)()
  }

  handleKycConsented = (kycTermsAgreed) => () => {
    this.setState({showKycConsent: false})
    if (!this.props.context.limitedUpdate) {
      this.props.onChange({...this.props.context, kycTermsAgreed})
    }
  }

  renderStatus = (person, i) => {
    const active = this.state.activeStatus === i
    const hoverable = this.state.activeStatus === -1
    const {kycTermsAgreed} = this.props.context
    return (
      <div className={styles({kycStatus: true, active, hoverable, [person.status]: true})} style={{zIndex: 100 - i}}>
        <div className={styles.statusLabel} onClick={this.handleStatusClick(i)}>
          <span className={styles.statusIcon}>
            <img src={`/icons/${person.status}.png`} alt={person.status}/>
          </span>
          <span className={styles.statusText}>{statusTitles[person.status]}</span>
          <ExpandMoreIcon className={styles.moreIcon}/>
        </div>

        <Typography>Added: {moment(person.createdAt).fromNow()}</Typography>
        {kycTermsAgreed ?
          <Typography variant='body1'>{person.status === 'unsent' ? 'Send' : 'Resend'} Instructions</Typography>
          :
          <Typography variant='body1'>KYC Consent Required</Typography>
        }
        {person.email && person.phone && person.role &&
          <Tooltip title='Email'>
            <IconButton onClick={this.handleSend('email', person)} disabled={!kycTermsAgreed}><EmailIcon/></IconButton>
          </Tooltip>
        }
        {Authorization.admin &&
          <Fragment>
            <Tooltip title='Edit'>
              <IconButton onClick={this.handleEditStatus(person)}><EditIcon/></IconButton>
            </Tooltip>

            {person.latestVerification && person.latestVerification.response &&
              <Tooltip title='View Results'>
                <IconButton onClick={this.handleViewResult(person)}><OpenIcon/></IconButton>
              </Tooltip>
            }
          </Fragment>
        }
      </div>
    )
  }

  render = () => {
    const {limitedUpdate, registeredFor} = this.props.context
    return (
      <ReadOnly on={this.props.review || limitedUpdate}>
        <FormContext
          context={this.props.context}
          onChange={this.props.onChange}
          errorContext={this.props.errorContext}
          metaRef={this.props.metaRef}
        >
          {this.props.context.personKycs.some(({email, phone, role, status}) => email && phone && role && status === 'unsent') &&
            <LinkButton className={styles.headlineLink} onClick={this.handleSend('email')}>Start KYC</LinkButton>
          }
          {this.props.context.personKycs.map((person, i) =>
            <div className={styles({section: true, disabledArea: limitedUpdate})} key={person.name}>
              {!limitedUpdate && person.id && this.renderStatus(person, i)}

              <Typography variant='h6' style={{paddingBottom: 10}}>
                {person.name}
                {person.type !== 'accountKycs' && <IconButton style={{marginTop: -20, marginBottom: -16}}  onClick={this.handleDeletePersonKyc(person)}><DeleteIcon/></IconButton>}
              </Typography>
              <TextField member={`personKycs[${i}].email`} errorMember={`personKycs['${person.name}'].email`}
                         meta={{prepopulated: i === 0, errorLabel: `${person.name}'s Email`}} required fullWidth/>
              <div style={{width: '50%', display: 'inline-block'}}>
                <CallingCodeSelect member={`personKycs[${i}].callingCode`} label='Country Dialing Code'
                                   countries={this.props.countries} required/>
              </div>
              <TextField member={`personKycs[${i}].phone`} errorMember={`personKycs['${person.name}'].phone`}
                         meta={{prepopulated: i === 0, errorLabel: `${person.name}'s Phone`}} required/>
              <TextField member={`personKycs[${i}].role`} errorMember={`personKycs['${person.name}'].role`}
                         meta={{prepopulated: i === 0, errorLabel: `${person.name}'s Role`}} required
                         disabled={registeredFor === 'individual'}/>
            </div>
          )}
          <div className={styles.section} style={{display: 'flex'}}>
            <Checkbox onClick={this.handleEditKycConsent} checked={this.props.context.kycTermsAgreed}
                      style={{marginLeft: -12, marginTop: -9}}/>
            <div>
              <MemberTitle member="kycTermsAgreed" variant="body1" required
                           meta={{requiredError: `You must consent to your information being used to complete KYC.`,
                                  errorLabel: 'KYC Consent'}}>
                I confirm that <LinkButton onClick={this.handleShowKycConsent}>I am authorised</LinkButton> to provide the personal
                details presented and <LinkButton onClick={this.handleShowKycConsent}>I consent</LinkButton> to my information being
                checked with the document issuer or official record holder via third party systems for the purpose
                of confirming my identity.
              </MemberTitle>

              <TextAgreement
                title="KYC Consent"
                open={this.state.showKycConsent}
                onConfirm={this.handleKycConsented(true)}
                onCancel={this.handleKycConsented(false)}
                disabled={limitedUpdate}
              >
                <Markdown mdtext={this.props.kycConsent.renderedContent} />
              </TextAgreement>
            </div>
          </div>
          <div className={styles.section}>
            {!limitedUpdate && registeredFor !== 'individual' && <Button className={styles.addButton} onClick={this.handleAddPersonKyc} fullWidth>Add Another Person</Button>}
            <InputDialog {...this.personKycDialogHandler.props} title="New Person" label="Full Name" valueRequired/>
            <InputDialog {...this.editStatusDialogHandler.props} title="Edit Status" label="Status">
              <Select options={statusOptions}/>
            </InputDialog>
            <InfoDialog {...this.viewResultDialogHandler.props} title="KYC Results" classes={{content: styles.flexColumn}}>
              <IdentityVerificationDetails personKyc={this.viewResultDialogHandler.props.personKyc} />
            </InfoDialog>
          </div>
        </FormContext>
      </ReadOnly>
    )
  }
}

const statusTitles = {
  unsent: 'KYC Not Started',
  pending: 'KYC Pending',
  complete: 'KYC Complete',
  failed: 'KYC Failed',
}

const statusOptions = Object.keys(statusTitles).map(value => ({value, label: statusTitles[value]}))